import React from "react";
import { useTranslation } from "react-i18next";
import Container from '../UI/Container/Container';
import classes from './PaymentMethods.module.scss'
import { Typography } from "antd";
import visaImg from '../../assets/images/visa.png';
import mastercardImg from '../../assets/images/mastercard.png';
import cashImg from '../../assets/images/cash.png';
import mapImg from '../../assets/images/map.png';

const PaymentMethods = () => {
    const { t } = useTranslation();

    return (
        <div className={classes.bg}>     
            <Container>
                <h2 className={classes.title}>{t('paymentmethods.title')}</h2>
                <div className={classes.block}>
                    <Typography className={classes.describtion}>{t('paymentmethods.ps')}</Typography>
                    <div className={classes.grid1}>
                        <img className={classes.image} src={visaImg}/>
                        <img className={classes.image} src={mastercardImg}/>
                    </div>
                    <Typography className={classes.describtion}>{t('paymentmethods.cash')}</Typography>
                    <div className={classes.grid2}>
                        <img className={classes.image} src={cashImg}/>
                        <img className={classes.image} src={mapImg}/>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default PaymentMethods;